import { PICKER_WIDGETS_LOAD, PICKER_INFO_LOAD, PICKER_SET_TEMPLATE, TABS } from './constants';
import _ from 'lodash';

const weditor = {
    widgets: {},
    info: {},
    template: null,
    tab: TABS.ALL,
    params: {},
};

export default (state = weditor, { type, payload }) => {
    switch (type) {
        case PICKER_WIDGETS_LOAD: {
            const widgets = { ...state.widgets };
            widgets[payload.set] = payload.widgets;
            return { ...state, widgets };
        }
        case PICKER_SET_TEMPLATE: {
            return { ...state, template: payload };
        }
        case PICKER_INFO_LOAD: {
            const info = { ...state.info };
            info[payload.set] = payload.data;
            return { ...state, info };
        }
    }
    return state;
};



/** WEBPACK FOOTER **
 ** ../src/dash/front/widget-picker/reducer.js
 **/